export default __webpack_public_path__ + "static/media/coresanscr95it-webfont.95136d68.woff2";